<app-additional-owners-required
  [borrowerId]="borrowerId"
  [contacts]="contacts"
  (resendRequiredComplete)="requiredComplete()">
</app-additional-owners-required>
<app-additional-owners-post-offer-verification
  [borrowerId]="borrowerId"
  [contacts]="contacts"
  (resendPostOfferVerificationComplete)="postOfferVerificationComplete()">
</app-additional-owners-post-offer-verification>
